import React from 'react';
import PropTypes from 'prop-types';

class StackedBar extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {};
  }

  render() {
    return (
      <div className="serving-logos-container">
        <div className="text">Serving charts on behalf of our customers around the world</div>
        <div className="logos items-center gap-16 place-items-center mt-12 md:mt-6">
          <img className="max-h-10 lg:max-h-24" src="https://app.everviz.com/static/images/logos/telegraph.svg" />
          <img className="max-h-24 lg:max-h-24" src="https://app.everviz.com/static/images/logos/riza.svg" />
          <img className="max-h-24 lg:max-h-24" src="https://app.everviz.com/static/images/logos/informa.small.png" />
          <img className="max-h-24 lg:max-h-24" src="https://app.everviz.com/static/images/logos/klima1.small.png" />
          <img className="max-h-24 lg:max-h-24" src="https://app.everviz.com/static/images/logos/hospice.small.png" />
          <img className="max-h-24 lg:max-h-24" src="https://app.everviz.com/static/images/logos/rpa.small.png" />
          <img className="max-h-10 lg:max-h-24" src="https://app.everviz.com/static/images/logos/uchicago.small.png" />
          <img
            className="max-h-24 md:max-h-16 lg:max-h-32"
            src="https://app.everviz.com/static/images/logos/becker.small.png"
          />
          <img className="max-h-24 lg:max-h-24" src="https://app.everviz.com/static/images/logos/spg-white.png" />
          <img className="max-h-24 lg:max-h-24" src="https://app.everviz.com/static/images/logos/ifs-white.png" />
        </div>
      </div>
    );
  }
}

StackedBar.propTypes = {};

export default StackedBar;
